import React from 'react';
import AppIcon from '../AppIcon';
import DockUtils from './DockUtils';
import { PREFERRED_ICON_TYPE } from '../../config/TypeConfig';

/**
 * Dock图标组件
 */
const DockIcon = ({ app, section, onIconClick }) => {
  if (!app) return null;

  // 处理图标加载错误
  const handleImageError = (e) => {
    // 触发图标加载错误事件
    const errorEvent = new CustomEvent('iconLoadError', {
      detail: { appId: app.id }
    });
    window.dispatchEvent(errorEvent);
  };

  return (
    <div 
      key={app.id || app.title} 
      className={`dock-icon ${section}`}
      data-app-id={app.id || app.title}
      data-section={section}
      onClick={() => onIconClick && onIconClick(app)}
    >
      <AppIcon 
        ico={app.ico}
        iconUrl={app.iconUrl}
        textIcon={app.textIcon}
        bgColor={app.bgColor}
        preferredIconType={app.preferredIconType}
        iconColor={app.iconColor || 'white'}
        onImageError={handleImageError}
        size={40}
        wrapperStyle={{
          borderRadius: '8px'
        }}
        imageStyle={{
          filter: app.bgColor === 'transparent' ? 'drop-shadow(0 0 1px rgba(0,0,0,0.2))' : undefined
        }}
      />
    </div>
  );
};

export default DockIcon;
